export type ZoneRoleName = 'COUNCILLOR' | 'SECRETARY_GENERAL' | 'STAFF';
export type IssueStatus = 'SUBMITTED' | 'ASSIGNED' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED';
export type IssuePriority = 'LOW' | 'NORMAL' | 'URGENT';
export type IssueEventType = 'CREATED' | 'ASSIGNED' | 'REASSIGNED' | 'STATUS_CHANGED' | 'REOPENED' | 'COMMENT';
export type IssueAction = 'start' | 'resolve' | 'confirm' | 'reopen';

export const STATUS_LABEL: Record<IssueStatus, string> = {
  SUBMITTED: 'Submitted',
  ASSIGNED: 'Assigned',
  IN_PROGRESS: 'In progress',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
};

export const PRIORITY_LABEL: Record<IssuePriority, string> = {
  LOW: 'Low',
  NORMAL: 'Normal',
  URGENT: 'Urgent',
};

export interface NamedRef { id: string; name: string }

export interface Zone { id: string; name: string; isActive: boolean; councillors: NamedRef[] }
export interface Category { id: string; name: string; isActive: boolean }

export interface ZoneMe {
  zoneRole: ZoneRoleName | null;
  isOrgAdmin: boolean;
  /** Only populated for councillors. */
  myZones: NamedRef[];
}

export interface IssueListItem {
  id: string;
  number: number;
  title: string;
  status: IssueStatus;
  priority: IssuePriority;
  zone: NamedRef;
  category: NamedRef | null;
  assignee: NamedRef | null;
  createdBy: NamedRef;
  createdAt: string;
  updatedAt: string;
  photoCount: number;
}

export interface IssueListPage { items: IssueListItem[]; total: number; page: number; pageSize: number }

export interface IssuePhotoRef { id: string; width: number; height: number }

export interface IssueEvent {
  id: string;
  type: IssueEventType;
  fromStatus: IssueStatus | null;
  toStatus: IssueStatus | null;
  comment: string | null;
  metadata: (Record<string, unknown> & {
    assigneeName?: string; previousAssigneeName?: string; categoryName?: string; previousCategoryName?: string;
  }) | null;
  createdAt: string;
  actor: NamedRef;
}

export interface IssueDetail {
  id: string;
  number: number;
  zoneId: string;
  title: string;
  description: string;
  priority: IssuePriority;
  locationText: string | null;
  lat: number | null;
  lng: number | null;
  status: IssueStatus;
  categoryId: string | null;
  assigneeId: string | null;
  createdById: string;
  resolvedAt: string | null;
  closedAt: string | null;
  createdAt: string;
  updatedAt: string;
  zone: NamedRef;
  category: NamedRef | null;
  assignee: NamedRef | null;
  createdBy: NamedRef;
  photos: IssuePhotoRef[];
  events: IssueEvent[];
}

/** Plain issue row returned by PATCH / assign / transitions (no relations). */
export type IssueSummary = Omit<IssueDetail, 'zone' | 'category' | 'assignee' | 'createdBy' | 'photos' | 'events'>;

export interface StatusCounts {
  SUBMITTED: number; ASSIGNED: number; IN_PROGRESS: number; RESOLVED: number; CLOSED: number;
}

export interface ZoneStats {
  byStatus: StatusCounts;
  byZone: Array<{ zoneId: string; name: string } & StatusCounts>;
  openByPriority: Record<IssuePriority, number>;
}

export interface IssueFilters {
  status?: IssueStatus;
  zoneId?: string;
  priority?: IssuePriority;
  mine?: boolean;
  q?: string;
  page?: number;
  pageSize?: number;
}

export interface IssueEditInput {
  title?: string;
  description?: string;
  priority?: IssuePriority;
  locationText?: string | null;
  lat?: number | null;
  lng?: number | null;
}

export interface TelegramStatus {
  enabled: boolean;
  linked: boolean;
  telegramNotifications: boolean;
  botUsername: string | null;
}
